var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutsourcing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "outsourcing",
    xmlns: "http://www.w3.org/2000/svg",
    width: 75.99,
    height: 76.001,
    viewBox: "0 0 75.99 76.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1585",
    "data-name": "Path 1585",
    d: "M74.673,21.015a1.3,1.3,0,0,0-.923-.6,1.345,1.345,0,0,0-1.072.285A6.671,6.671,0,0,1,63.3,11.325a1.384,1.384,0,0,0,.285-1.072,1.348,1.348,0,0,0-.6-.923,38.082,38.082,0,0,0-12.7-5.293,2.219,2.219,0,0,0-.3-.027,1.353,1.353,0,0,0-1.344,1.208,6.675,6.675,0,0,1-13.273,0,1.356,1.356,0,0,0-1.086-1.181,1.5,1.5,0,0,0-.258-.027h-.014a.792.792,0,0,0-.312.041A38.316,38.316,0,0,0,21.026,9.33a1.3,1.3,0,0,0-.6.923,1.4,1.4,0,0,0,.285,1.072A6.671,6.671,0,0,1,11.336,20.7a1.332,1.332,0,0,0-1.072-.285,1.348,1.348,0,0,0-.923.6A38.151,38.151,0,0,0,4.048,33.731a1.346,1.346,0,0,0,.231,1.086,1.363,1.363,0,0,0,.964.556,6.673,6.673,0,0,1,0,13.273,1.391,1.391,0,0,0-.964.556,1.346,1.346,0,0,0-.231,1.086A38.151,38.151,0,0,0,9.341,63a1.3,1.3,0,0,0,.923.6,1.345,1.345,0,0,0,1.072-.285,6.671,6.671,0,0,1,9.378,9.378,1.384,1.384,0,0,0-.285,1.072,1.348,1.348,0,0,0,.6.923,38.082,38.082,0,0,0,12.7,5.293A1.393,1.393,0,0,0,35.384,78.8a6.675,6.675,0,0,1,13.273,0,1.355,1.355,0,0,0,1.357,1.208,1.016,1.016,0,0,0,.285-.027A38.082,38.082,0,0,0,63,74.69a1.3,1.3,0,0,0,.6-.923,1.4,1.4,0,0,0-.285-1.072,6.671,6.671,0,0,1,9.378-9.378,1.369,1.369,0,0,0,1.072.285,1.348,1.348,0,0,0,.923-.6A38.317,38.317,0,0,0,79.98,50.3a1.848,1.848,0,0,0,.027-.285V49.99a1.367,1.367,0,0,0-.041-.339A1.346,1.346,0,0,0,78.8,48.633a6.673,6.673,0,0,1,0-13.273,1.373,1.373,0,0,0,1.181-1.072,1.84,1.84,0,0,0,.027-.271.827.827,0,0,0-.041-.326,38.316,38.316,0,0,0-5.279-12.676ZM70.1,42a9.377,9.377,0,0,0,6.894,9.052,35.279,35.279,0,0,1-3.868,9.283,9.4,9.4,0,0,0-12.8,12.8A35.47,35.47,0,0,1,51.046,77a9.39,9.39,0,0,0-18.1,0,35.279,35.279,0,0,1-9.283-3.868,9.4,9.4,0,0,0-12.8-12.8,35.74,35.74,0,0,1-3.868-9.283,9.39,9.39,0,0,0,0-18.1,35.09,35.09,0,0,1,3.868-9.283,9.4,9.4,0,0,0,12.8-12.8A35.47,35.47,0,0,1,32.941,7a9.39,9.39,0,0,0,18.1,0,35.279,35.279,0,0,1,9.283,3.868,9.4,9.4,0,0,0,12.8,12.8,35.47,35.47,0,0,1,3.868,9.283A9.365,9.365,0,0,0,70.1,42Z",
    transform: "translate(-4.017 -4.01)",
    fill: "#7d0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1586",
    "data-name": "Path 1586",
    d: "M38.428,14A24.428,24.428,0,1,0,62.857,38.428,24.456,24.456,0,0,0,38.428,14ZM60.075,39.786a21.6,21.6,0,0,1-5.4,13,24.981,24.981,0,0,0-4.18-3.026,41.154,41.154,0,0,0,1.479-9.989h2.755V37.058H51.973a41.154,41.154,0,0,0-1.479-9.989,24.237,24.237,0,0,0,4.18-3.026,21.633,21.633,0,0,1,5.4,13H57.428v2.714h2.646Zm-23-12.282A21.574,21.574,0,0,1,29.7,25.726c1.737-4.709,4.384-8.034,7.369-8.821Zm0,2.714v6.854H27.612a38.625,38.625,0,0,1,1.262-8.726,24.41,24.41,0,0,0,8.211,1.886Zm0,9.568v6.854a24.41,24.41,0,0,0-8.211,1.886A38.739,38.739,0,0,1,27.6,39.8h9.459Zm0,9.568v10.6c-2.986-.787-5.632-4.112-7.369-8.821A21.575,21.575,0,0,1,37.071,49.353Zm2.714,0a21.574,21.574,0,0,1,7.369,1.778c-1.737,4.709-4.384,8.034-7.369,8.821Zm0-2.714V39.786h9.459a38.625,38.625,0,0,1-1.262,8.726,24.41,24.41,0,0,0-8.211-1.886Zm0-9.568V30.218A24.41,24.41,0,0,0,48,28.331a38.739,38.739,0,0,1,1.262,8.726H39.8Zm0-9.568V16.9c2.986.787,5.632,4.112,7.369,8.821A21.574,21.574,0,0,1,39.786,27.5Zm6.3-9.378a21.968,21.968,0,0,1,6.677,4.017,21.318,21.318,0,0,1-3.135,2.294,22.4,22.4,0,0,0-3.542-6.311ZM27.246,24.436a22.062,22.062,0,0,1-3.135-2.294,21.968,21.968,0,0,1,6.677-4.017A22.4,22.4,0,0,0,27.246,24.436Zm-.869,2.646A41.154,41.154,0,0,0,24.9,37.071H16.782a21.6,21.6,0,0,1,5.4-13,24.981,24.981,0,0,0,4.18,3.026ZM24.9,39.786a41.154,41.154,0,0,0,1.479,9.989A24.237,24.237,0,0,0,22.2,52.8a21.633,21.633,0,0,1-5.4-13h8.116Zm2.348,12.621a22.4,22.4,0,0,0,3.542,6.311A21.968,21.968,0,0,1,24.111,54.7a21.318,21.318,0,0,1,3.135-2.294Zm22.379,0A22.062,22.062,0,0,1,52.76,54.7a21.968,21.968,0,0,1-6.677,4.017,22.4,22.4,0,0,0,3.542-6.311Z",
    transform: "translate(-0.452 -0.442)",
    fill: "#7d0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1587",
    "data-name": "Path 1587",
    d: "M31,6h2.714V8.714H31Z",
    transform: "translate(5.619 -3.299)",
    fill: "#7d0000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1588",
    "data-name": "Path 1588",
    d: "M31,56h2.714v2.714H31Z",
    transform: "translate(5.619 14.557)",
    fill: "#7d0000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1589",
    "data-name": "Path 1589",
    d: "M56,31h2.714v2.714H56Z",
    transform: "translate(14.547 5.629)",
    fill: "#7d0000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1590",
    "data-name": "Path 1590",
    d: "M6,31H8.714v2.714H6Z",
    transform: "translate(-3.309 5.629)",
    fill: "#7d0000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1591",
    "data-name": "Path 1591",
    d: "M0,0H2.714V2.714H0Z",
    transform: "translate(60.035 13.993) rotate(-45)",
    fill: "#7d0000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1592",
    "data-name": "Path 1592",
    d: "M0,0H2.714V2.714H0Z",
    transform: "translate(12.06 61.98) rotate(-45)",
    fill: "#7d0000"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1593",
    "data-name": "Path 1593",
    d: "M0,0H2.714V2.714H0Z",
    transform: "translate(60.034 61.98) rotate(-45)",
    fill: "#7d0000"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1594",
    "data-name": "Path 1594",
    d: "M0,0H2.714V2.714H0Z",
    transform: "translate(12.061 13.992) rotate(-45)",
    fill: "#7d0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutsourcing);
export default __webpack_public_path__ + "static/media/outsourcing.5bb63723016c4e4808ce7e6fa6016bca.svg";
export { ForwardRef as ReactComponent };